import { GlobalService } from '../../services/global.service';
import { Subscription } from 'rxjs';
import { TicketManager } from '../../managers/ticket.manager';
import { AdminItem } from '../../models/domain/admin.item';
import { AdminPresenceService } from '../../services/admin.presence.service';
import { TicketService } from '../../services/ticket.service';
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { DialogService } from '../../services/modal-dialogs';
import { CustomTicketWidgetItemArray, CustomTicketWidgetItem } from '../../models/domain/custom.ticket.widget';
import { ssApiService } from '../../services/ss-api.service';
import { IBaseResponse } from '../../models/comm-http/responses/BaseResponse';
import { CustomTicketsAdminGlobalsResponse } from '../../models/ss-api/responses/custom.tickets.admin.globals.response';
import { CustomTicketsAdminTotalsArray } from '../../models/domain/custom.tickets.admin.totals';
import { CustomTicketAssignResponse } from '../../models/ss-api/responses/custom.ticket.assign.response';
import { TicketAssignAdminRequest } from '../../models/ss-api/requests/ticket.assign.admin.request';
import { WindowSettings } from '../../../app/services/window-dialogs/window.settings';
import { WindowTypes, WindowActionTypes } from '../../../app/services/window-dialogs/window.event';
import { WindowService } from '../../../app/services/window-dialogs/window.service';
import { TicketAddWindowData } from '../../dialog-windows/ticket.add/ticket.add.window';
import { AdminHistoryService } from '../../../app/services/admin.history.service';

// import { TicketDetailsDialogComponent } from "app/shared/dialogs/ticket-details/ticket-details.dialog.component";


@Component({
    selector: 'ticket-panel',
    templateUrl: './ticket.panel.component.html',
    styleUrls: ['./ticket.panel.component.css']
})
export class TicketPanelComponent implements OnInit, OnDestroy {
    public TicketNumber: string;
    public MyTicketsCount: number = 0;
    public UnclaimedTicketsCount: number = 0;
    public PastDueTicketCount: number = 0;

    public Widgets: CustomTicketWidgetItemArray = new CustomTicketWidgetItemArray();
    public Totals: CustomTicketsAdminTotalsArray = new CustomTicketsAdminTotalsArray();

    public IsBusy: boolean = false;

    draggedTicket: boolean;

    private ticketOnBusyChangedSubscription: Subscription;
    private onMyTotalsChanged: Subscription;
    private onPresence: Subscription;
    private ReloadTicketsSubscription: Subscription;
    private onPresenceList: Subscription;
    private TicketSubscription: Subscription;

    constructor(
        private dialogService: DialogService,
        public ticketService: TicketService,
        public AdminPresence: AdminPresenceService,
        private changeDetect: ChangeDetectorRef,
        public api: ssApiService,
        private gb: GlobalService,
        public historyService: AdminHistoryService,
        private windowService: WindowService) {
    }

    ngOnInit() {

        this.ticketOnBusyChangedSubscription = this.ticketService.onBusyChanged.subscribe((value) => {
            this.IsBusy = value
            this.changeDetect.detectChanges();
        });

        this.onMyTotalsChanged = this.ticketService.onMyTotalsChanged.subscribe((data) => {
            this.MyTicketsCount = data.MyTickets;
            this.UnclaimedTicketsCount = data.UnclaimedTickets;
            this.changeDetect.detectChanges();
        })

        this.onPresence = this.AdminPresence.onAdminPresenceChanged.subscribe((data) => {
            this.changeDetect.detectChanges();
        })

        this.onPresenceList = this.AdminPresence.onAdminPresenceFullList.subscribe((data) => {
            this.changeDetect.detectChanges();
        })

        this.ReloadTicketsSubscription = this.api.onCustomTicketsReload.subscribe(x => {
            this.LoadTickets();
        });

        this.LoadTickets();
    }


    ngOnDestroy() {
        this.ticketOnBusyChangedSubscription.unsubscribe();
        this.onMyTotalsChanged.unsubscribe();
        this.onPresence.unsubscribe();
        this.onPresenceList.unsubscribe();
        // this.TicketSubscription.unsubscribe();
    }

    LoadTickets() {
        this.IsBusy = true;
        let subscription = this.api.GetCustomTicketsAdminGlobals(this.gb.AdminId).subscribe(
            async (result: IBaseResponse<CustomTicketsAdminGlobalsResponse>) => {
                subscription.unsubscribe();

                if (!result.Result) {
                    this.IsBusy = false;
                    // console.log("Error", result.Message);
                    return;
                }

                this.Widgets = result.Data.Widgets;
                this.Totals = result.Data.Totals;
                this.UnclaimedTicketsCount = result.Data.NotAssigned;
                this.PastDueTicketCount = result.Data.CurrentAdminPastDueCount;

                if (this.Widgets) {
                    this.Widgets = this.Widgets.filter((widget) => {
                        return new Date(widget.DueDate).setHours(0, 0, 0, 0) <= new Date().setHours(0, 0, 0, 0);
                    })
                }

                this.IsBusy = false;
            }, (error: any) => {
                subscription.unsubscribe();
                // console.log("Ticket Error: ", error);
                this.IsBusy = false;
            }
        );
    }

    openTicketDetailsDialog() {
        let newTicket = new TicketManager();
        newTicket.SetAddMode(this.gb.AdminId, this.gb.FullName, 'New Admin Ticket');
    }

    async addNewTicketDialog() {

        let windowSettings = new WindowSettings();
        windowSettings.Height = 900;
        windowSettings.Width = 1240;

        let MemberOptions = [];
        MemberOptions.push({ label: 'None', value: 0 });
        let ticketWindowData = new TicketAddWindowData;

        await this.api.AdminBrowseLogs(this.gb.AdminHistoryMaxResults).subscribe(response => {
            // disposable.unsubscribe();

            response.Data.forEach(x => {
                if (x.MemberID != null && x.MemberID != undefined) {
                    MemberOptions.push({ label: x.MemberName, value: x.MemberID });
                }

                ticketWindowData.MemberOptions = MemberOptions;

            });

        });

        let result = this.windowService.OpenWindow<TicketAddWindowData>(WindowTypes.TicketAdd, ticketWindowData, windowSettings);

        let subscription = result.onEvent.subscribe(event => {

            if (event.ActionType == WindowActionTypes.Saved) {
                this.IsBusy = true;
                this.LoadTickets();
            }

            if (event.ActionType == WindowActionTypes.Close) {
                subscription.unsubscribe();
            }

        });

    }

    InitMemberOptions() {
        this.historyService.Refresh();
        let MemberOptions = [];
        MemberOptions.push({ label: 'None', value: 0 });

        let disposable = this.api.AdminBrowseLogs(this.gb.AdminHistoryMaxResults).subscribe(response => {
            disposable.unsubscribe();
            // response.Data[0].
            response.Data.forEach(x => {
                if (x.MemberID != null && x.MemberID != undefined) {
                    MemberOptions.push({ label: x.MemberName, value: x.MemberID });
                }
            });

        });



    }

    AddTicketForAdmin(admin: AdminItem) {
        let newTicket = new TicketManager();
        newTicket.SetAddMode(admin.AdminID, admin.FirstName + ' ' + admin.LastName, 'New Admin Ticket', this.gb.LastMemberID, 'Member Name');
    }

    SearchTicket() {
        let disposable = new TicketManager(0, true, this.TicketNumber);
    }

    RefreshTicketing() {
        this.ticketService.RefreshOwn();
    }

    MyTicketsTotals(): number {
        let total = 0;
        // this.Totals.forEach(x => { total += x.Total });

        return total;
    }

    ticketDropped(e: any) {
        this.draggedTicket = false;

        if (this.gb.DraggedTicket) {
            let reassignTicket: CustomTicketWidgetItem = this.gb.DraggedTicket;
            let request = new TicketAssignAdminRequest;
            request.AdminID = Number(this.gb.AdminId);
            request.TicketID = reassignTicket.TicketID;
            let subscription = this.api.CustomTicketAssignAdmin(request).subscribe(
                async (result: IBaseResponse<CustomTicketAssignResponse>) => {
                    subscription.unsubscribe();

                    if (!result.Result) {
                        this.IsBusy = false;
                        return;
                    }

                    this.IsBusy = false;
                }, (error: any) => {
                    subscription.unsubscribe();
                    this.IsBusy = false;
                }
            ); ;
        }

    }


    dragEnter(event) {
        this.draggedTicket = true;
    }

    dragExit(event) {
        this.draggedTicket = false;
    }

}
